<template lang="html">
  <boxwrap class="admin-list--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <select2
          class="toolbar-nav"
          v-model="selectedList"
        >
          <option2
            v-for="(statusItem, statusKey) of statusList"
            :key="statusKey"
            :value="statusItem.value"
            :name="statusItem.display"
            :selected="selectedList === statusItem.value"
          >
            {{ statusItem.display }}
          </option2>
        </select2>

        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        />

        <!-- button
          class="btn--create"
          title="create"
        >
          <i class="ico--create"></i>
        </button -->

        <div class="toolbar-rightbtns">
          <!-- button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button -->
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{ 'data-loading': showDataLoading }">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty || !logs.list.length"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty || !logs.list.length"
      />

      <tbl
        :scrollable="true"
      >
        <tbl-inner>
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="no"
                :sort="true"
                v-if="checkCol('id', tblSetting)"
                @click.native="sort('id')"
              >
                <!-- no -->
                번호
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('created_at', tblSetting)"
                @click.native="sort('created_at')"
                name="created-at"
              >
                <!-- created -->
                생성일
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('login_id', tblSetting)"
                @click.native="sort('login_id')"
                name="login-id"
              >
                <!-- super administrator id -->
                아이디
              </tbl-td>

              <tbl-td
                name="login-name"
                :sort="true"
                v-if="checkCol('login_name', tblSetting)"
                @click.native="sort('login_name')"
              >
                <!-- super administrator name -->
                관리자명
              </tbl-td>

              <tbl-td
                name="memo"
                :sort="true"
                v-if="checkCol('memo', tblSetting)"
                @click.native="sort('memo')"
              >
                <!-- memo -->
                메모
              </tbl-td>

              <!-- <tbl-td
                :sort="true"
                v-if="checkCol('pages', tblSetting)"
                @click.native="sort('pages')"
                name="pages"
              >
                위치
              </tbl-td> -->

              <!-- <tbl-td
                :sort="true"
                v-if="checkCol('origin_id', tblSetting)"
                @click.native="sort('origin_id')"
                name="origin-id"
              >
                로그
              </tbl-td> -->

              <tbl-td
                name="origin"
                :sort="true"
                v-if="checkCol('origin', tblSetting)"
                @click.native="sort('origin')"
              >
                페이지
              </tbl-td>

              <tbl-td
                name="ip"
                :sort="true"
                v-if="checkCol('ip', tblSetting)"
                @click.native="sort('ip')"
              >
                아이피
              </tbl-td>

              <tbl-td
                name="domain"
                :sort="true"
                v-if="checkCol('domain', tblSetting)"
                @click.native="sort('domain')"
              >
                도메인
              </tbl-td>

              <tbl-td
                name="actions"
                :sort="true"
                v-if="checkCol('action', tblSetting)"
                @click.native="sort('action')"
              >
                활동
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(superAdminVal, superAdminKey) in logs.list"
              :key="superAdminKey"
            >
              <tbl-td name="no">
                {{ generateNumber(superAdminKey, params.page, params.rows, params.sort, logs.count) }}
              </tbl-td>

              <tbl-td name="created-at">
                {{ dateFormatter(superAdminVal.creates_at) }}
              </tbl-td>

              <tbl-td name="lopgin-id">
                {{ superAdminVal.login_id || '-' }}
              </tbl-td>

              <tbl-td name="login-name">
                {{ superAdminVal.login_name || '-' }}
              </tbl-td>

              <tbl-td name="memo">
                {{ superAdminVal.memo || '-' }}
              </tbl-td>

              <!-- <tbl-td name="pages">
                {{ superAdminVal.pages || '-' }}
              </tbl-td> -->

              <!-- <tbl-td name="origin-id">
                {{ superAdminVal.origin_id || '-' }}
              </tbl-td> -->

              <tbl-td name="origin">
                {{ superAdminVal.origin }}
              </tbl-td>

              <tbl-td name="ip">
                {{ superAdminVal.ip }}
              </tbl-td>

              <tbl-td name="domain">
                {{ superAdminVal.domain }}
              </tbl-td>

              <tbl-td name="actions">
                <div v-if="actionsList.includes(superAdminVal.action)">
                  <span v-if="superAdminVal.action === 'login'">
                    로그인
                  </span>

                  <span v-if="superAdminVal.action === 'logout'">
                    로그아웃
                  </span>

                  <span v-if="superAdminVal.action === 'modify'">
                    수정
                  </span>

                  <span v-if="superAdminVal.action === 'updated'">
                    업데이트
                  </span>

                  <span v-if="superAdminVal.action === 'create'">
                    생성
                  </span>                  
                  <span v-if="superAdminVal.action === 'insert'">
                    추가
                  </span>    
                  <span v-if="superAdminVal.action === 'deleted'">
                    삭제
                  </span>                                    
                </div>

                <div v-else>
                  {{ superAdminVal.action }}
                </div>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="logs.count"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          />
        </tbl-footer>
      </tbl>
    </boxwrap-contents>
  </boxwrap>

</template>

<script>
//= components
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import '@/components/base/select/Select'
import Search from '@/components/base/search/Search'
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'
import CheckDataList from '@/components/base/CheckDataList'
export default {
  name: 'admin-logs',

  components: {
    Pagination,
    Modal,
    Search,
    Checkbox,
    CheckDataList
  },

  mixins: [
    getListStatus,
    swal
  ],

  data () {
    return {
      isEmpty: false,
      isDataLoading: true,
      showDataLoading: false,
      showCreate: false,
      showModify: false,

      filterBy: [
        {
          value: 'login_id',
          display: '아이디'
        },
        {
          value: 'login_name',
          display: '닉네임'
        },
        {
          value: 'ip',
          display: 'ip'
        },
        {
          value: 'origin',
          display: '원본'
        },
        {
          value: 'domain',
          display: '도메인'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: '생성일자'
        }
      ],

      tblSetting: 'adminlogs',

      allCols: [
        {
          display: 'no',
          value: 'no'
        },
        {
          display: 'created at',
          value: 'created_at'
        },
        {
          display: 'login id',
          value: 'login_id'
        },
        {
          display: 'login name',
          value: 'login_name'
        },
        {
          display: 'pages',
          value: 'pages'
        },
        {
          display: 'origin id',
          value: 'origin_id'
        },
        {
          display: 'origin',
          value: 'origin'
        },
        {
          display: 'ip',
          value: 'ip'
        },
        {
          display: 'domain',
          value: 'domain'
        }
      ],

      statusList: [
        {
          value: 'all',
          display: '전체'
        },
        {
          value: 'insert',
          display: '추가'
        },
        {
          value: 'login',
          display: '로그인'
        },
        {
          value: 'logout',
          display: '로그아웃'
        },
        {
          value: 'deleted',
          display: '삭제'
        },
        {
          value: 'updated',
          display: '업데이트'
        },
        {
          value: 'modify',
          display: '수정'
        },        
        {
          value: 'create',
          display: '생성'
        }                  
      ]
    }
  },

  computed: {
    ...mapState('superadmin-logs', ['logs']),

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    },

    actionsList () {
      return [
        'login',
        'logout',
        'modify',
        'create',
        'deleted',
        'updated',
        'insert',
      ]
    }
  },

  watch: {
    async '$route' ($router) {
       if (!this.showDataLoading) {
         this.showDataLoading = true
       }

       this.search(this.generate($router.query))
    }
  },

  async created () {
     if (this.$route.params.status === undefined) {
       this.$router.push(`${this.$route.path}/`)
     }

     this.query = this.generate(this.query)
     this.search()
  },

  methods: {
    ...mapActions('superadmin-logs', { list: 'list' }),

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async sort(arg){
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = arg
      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.query = query || this.query
      this.status = this.$route.params.status

       // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.list({
        params: this.query,
        status: this.$route.params.status
      })

      this.isDataLoading = false
      this.showDataLoading = false

      if (!this.log && !this.log.length) {
        this.isEmpty = true
      }
    },

    dateFormatter(value) {
      return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
